import { render } from "./ScoreView.vue?vue&type=template&id=310df1fd&scoped=true"
import script from "./ScoreView.vue?vue&type=script&lang=js"
export * from "./ScoreView.vue?vue&type=script&lang=js"

import "./ScoreView.vue?vue&type=style&index=0&id=310df1fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310df1fd"]])

export default __exports__